import { createStore, getStores, deleteStore, updateStore } from '../services/Api';

const create = async ( name, description, cnpj, phone ) => {
    try {
        const response = await createStore( name, description, cnpj, phone );
        return response;
    } catch (err) {
        console.log("err to save store "+ err)
        return null;
    }
};

const getStoresFromDatabase = async () => {
    try {
        const response = await getStores();
        return response;
    } catch (err) {
        console.log("err to get stores "+ err)
        return null;
    }
};

const deleteStoreFromDatabase = async (storeId) => {
    try {
        const response = await deleteStore(storeId);
        return response;
    } catch (err) {
        console.log("err to delete stores "+ err)
        return null;
    }
};

const editStoreFromDatabase = async ( storeData ) => {
    try {
        const response = await updateStore(storeData);
        return response;
    } catch (err) {
        console.log("err to edit stores "+ err)
        return null;
    }
};

export {
    create,
    getStoresFromDatabase,
    deleteStoreFromDatabase,
    editStoreFromDatabase
 };